(()=> {
  const registry = new Map();
  function typeOf(el){ return el?.dataset.section || el?.dataset.sectionType || el?.getAttribute('data-section-type'); }
  function init(el){ const t = typeOf(el); const mod = registry.get(t); if (mod?.init) mod.init(el); }
  function unload(el){ const t = typeOf(el); const mod = registry.get(t); if (mod?.unload) mod.unload(el); }

  window.VH = {
    register(type, mod){ registry.set(type, mod); },
    utils:{
      prefersReduced: !!(matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches),
      rafBatch(fn){ let id=0; return (...a)=>{ if(id) return; id=requestAnimationFrame(()=>{id=0; fn(...a);}); }; },
      on(el,ev,h,opts){ el?.addEventListener(ev,h,opts); return ()=>el?.removeEventListener(ev,h,opts); }
    }
  };

  // Block clicks on aria-disabled links
  document.addEventListener('click',(e)=>{
    const a = e.target.closest('a[aria-disabled="true"]');
    if(a){ e.preventDefault(); e.stopPropagation(); }
  }, { capture:true });

  // Bootstrap + Theme Editor lifecycle
  document.addEventListener('DOMContentLoaded', ()=> {
    document.querySelectorAll('[data-section]').forEach(init);
  });
  document.addEventListener('shopify:section:load', e=> init(e.target));
  document.addEventListener('shopify:section:unload', e=> unload(e.target));
})();

/* --- VH namespace shim (keep both registry styles working) --- */
(function () {
  const prev = (window.VH && window.VH.register) || null;
  window.VH = window.VH || {};
  window.VH.modules = window.VH.modules || new Map();
  window.VH.register = function (name, mod) {
    // feed the old registry (if present)
    if (typeof prev === 'function') { try { prev(name, mod); } catch (_) {} }
    // also feed the modules map used by newer blocks
    try { window.VH.modules.set(name, mod); } catch (_) {}
  };
})();

/* --------------------------------------------------------
   SECTION: Splash Video (vh-splash-video)
   -------------------------------------------------------- */
(function() {
  const SELECTORS = {
    video: '.vh-splash-video__el',
    toggle: '[data-js="toggle"]',
    textSpan: 'span'
  };

  /**
   * IntersectionObserver to auto-pause video when off-screen.
   * Saves CPU/Battery when user scrolls down.
   */
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const video = entry.target;
      if (!entry.isIntersecting && !video.paused) {
        video.pause();
        video.dataset.pausedByScroll = "true";
      } else if (entry.isIntersecting && video.dataset.pausedByScroll === "true") {
        // Only resume if we paused it via scroll, not if user paused it manually
        video.play().catch(() => {}); // catch interrupt errors
        delete video.dataset.pausedByScroll;
      }
    });
  }, { threshold: 0.1 });

  const init = (root) => {
    if (!root || root.getAttribute('data-section') !== 'vh-splash-video') return;

    const video = root.querySelector(SELECTORS.video);
    const toggle = root.querySelector(SELECTORS.toggle);
    
    // Safety check
    if (!video) return;

    // 1. Performance: Mark ready state to avoid FOUC
    const onMeta = () => root.setAttribute('data-ready', 'true');
    if (video.readyState >= 1) onMeta();
    else video.addEventListener('loadedmetadata', onMeta, { once: true });

    // 2. A11y & Preference: Handle Reduced Motion
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) {
      video.removeAttribute('autoplay');
      video.pause();
    } else {
      // Observe for scroll pausing only if motion is allowed
      observer.observe(video);
    }

    // 3. Toggle Logic (Play/Pause)
    const updateUI = () => {
      if (!toggle) return;
      
      const isPlaying = !video.paused && !video.ended;
      const span = toggle.querySelector(SELECTORS.textSpan);
      
      // Update ARIA
      toggle.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
      toggle.setAttribute('aria-label', isPlaying 
        ? toggle.dataset.labelPause 
        : toggle.dataset.labelPlay
      );

      // Update Text Label
      if (span) {
        span.textContent = isPlaying 
          ? (toggle.dataset.labelPause || 'Pause') 
          : (toggle.dataset.labelPlay || 'Play');
      }
    };

    const handleToggle = (e) => {
      if (e) e.preventDefault();
      if (video.paused || video.ended) {
        video.play().catch(() => {});
        delete video.dataset.pausedByScroll; // User manual override clears scroll logic
      } else {
        video.pause();
      }
    };

    // 4. Bind Events
    if (toggle) {
      toggle.addEventListener('click', handleToggle);
    }

    video.addEventListener('play', updateUI);
    video.addEventListener('pause', updateUI);
    video.addEventListener('ended', updateUI);

    // Initial Sync
    updateUI();

    // 5. Cleanup Storage (for Unload)
    root._vh_teardown = () => {
      observer.unobserve(video);
      if (toggle) toggle.removeEventListener('click', handleToggle);
      video.removeEventListener('play', updateUI);
      video.removeEventListener('pause', updateUI);
      video.removeEventListener('ended', updateUI);
    };
  };

  const teardown = (root) => {
    if (root && root._vh_teardown) {
      root._vh_teardown();
      delete root._vh_teardown;
    }
  };

  // Lifecycle Hooks: Standard Shopify Patterns
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:unload', (e) => teardown(e.target));
  
  // Initialize on Page Load
  document.querySelectorAll('[data-section="vh-splash-video"]').forEach(init);
})();

/**
 * VIVID Header — Consolidated Controller (V2.3 RESTORED)
 * Handles: Mobile Menu, Translucent Scroll, Main Nav Hover Pill, 
 * Locale Dropdown (Restored Logic), Cart Updates, and Layout Offsets.
 */
(function () {
  'use strict';

  // --- Utilities ---
  const qs = (s, p = document) => p.querySelector(s);
  const qsa = (s, p = document) => Array.from(p.querySelectorAll(s));
  const raf = (fn) => window.requestAnimationFrame(fn);
  const isMobile = () => window.matchMedia('(max-width: 767.98px)').matches;

  class VividHeader {
    constructor(root) {
      this.root = root;
      this.elements = {
        bars: qsa('.vh-bar', root),
        mobileMenu: qs('.vh-menu', root),
        toggleBtn: qs('#vh-toggle', root),
      };

      // Configuration
      this.settings = {
        glassThreshold: 6, // px to scroll before glass effect
        announceSel: [
          '.announcement-bar-section',
          '#shopify-section-announcement-bar',
          '.utility-bar'
        ].join(',')
      };

      // State
      this.state = {
        isOpen: false,
        trapFocus: null,
        observers: [],
        cleanupFns: []
      };

      this.init();
    }

    init() {
      this.initScrollGlass();
      this.initMobileMenu();
      this.initHoverPills(); 
      this.initLocale();     // Restored "Nuclear Option" Logic
      this.initCartListener();
      this.initAnnouncementOffset();
      this.initFocusHygiene();
    }

    // ============================================================
    // 1. Scroll & Glass Effect
    // ============================================================
    initScrollGlass() {
      const updateGlass = () => {
        const y = window.scrollY || 0;
        const isGlassy = y > this.settings.glassThreshold;
        
        this.elements.bars.forEach(bar => {
          bar.classList.toggle('is-glassy', isGlassy);
        });
        
        if (isMobile()) {
          this.root.classList.toggle('vh-scrolled', isGlassy);
        }
      };

      window.addEventListener('scroll', () => raf(updateGlass), { passive: true });
      updateGlass(); 
    }

    // ============================================================
    // 2. Mobile Menu (Burger)
    // ============================================================
    initMobileMenu() {
      const { toggleBtn, mobileMenu } = this.elements;
      if (!toggleBtn || !mobileMenu) return;

      const toggle = (e) => {
        if (e) { e.preventDefault(); e.stopPropagation(); }
        this.state.isOpen ? this.closeMenu() : this.openMenu();
      };

      toggleBtn.addEventListener('click', toggle);

      qsa('a', mobileMenu).forEach(link => {
        link.addEventListener('click', () => this.closeMenu());
      });

      // Close Main Menu on Outside Click
      document.addEventListener('click', (e) => {
        if (this.state.isOpen && 
            !mobileMenu.contains(e.target) && 
            !toggleBtn.contains(e.target)) {
          this.closeMenu();
        }
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.state.isOpen) this.closeMenu();
      });
    }

    openMenu() {
      if (this.state.isOpen) return;
      this.state.isOpen = true;
      
      const { toggleBtn, mobileMenu } = this.elements;
      this.root.classList.add('vh-open');
      mobileMenu.classList.add('is-open');
      
      toggleBtn.setAttribute('aria-expanded', 'true');
      mobileMenu.setAttribute('aria-hidden', 'false');
      mobileMenu.style.visibility = 'visible';

      this.state.prevFocus = document.activeElement;
      const firstFocus = qs('a, button, input', mobileMenu);
      if (firstFocus) setTimeout(() => firstFocus.focus(), 50);

      this.initFocusTrap(mobileMenu);
    }

    closeMenu() {
      if (!this.state.isOpen) return;
      this.state.isOpen = false;

      const { toggleBtn, mobileMenu } = this.elements;
      this.root.classList.remove('vh-open');
      mobileMenu.classList.remove('is-open');
      
      toggleBtn.setAttribute('aria-expanded', 'false');
      mobileMenu.setAttribute('aria-hidden', 'true');

      if (this.state.prevFocus) this.state.prevFocus.focus();
      if (this.state.trapFocus) {
        document.removeEventListener('keydown', this.state.trapFocus);
        this.state.trapFocus = null;
      }
    }

    initFocusTrap(container) {
      this.state.trapFocus = (e) => {
        if (e.key !== 'Tab') return;
        const focusables = qsa('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])', container);
        const first = focusables[0];
        const last = focusables[focusables.length - 1];

        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault(); last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault(); first.focus();
        }
      };
      document.addEventListener('keydown', this.state.trapFocus);
    }

    // ============================================================
    // 3. Traveling Hover Pill (Main Nav)
    // ============================================================
    initHoverPills() {
      const getTargets = (bar) => {
        const all = qsa('a, button, .vh-locale-chip__field', bar);
        return all.filter((el) => {
          if (el.closest('.vh-logo')) return false; 
          if (el.matches('.vh-locale-chip__chev-btn') || el.closest('.vh-locale-chip__chev-btn')) return false;
          if (el.closest('.vh-locale-menu')) return false;
          return el.offsetParent !== null;
        });
      };

      this.elements.bars.forEach(bar => {
        if (!qs('.vh-hover-pill', bar)) {
          const span = document.createElement('span');
          span.className = 'vh-hover-pill';
          span.setAttribute('aria-hidden', 'true');
          bar.prepend(span);
        }
      });
      
      const syncPills = () => {
        if (isMobile()) return;

        let maxW = 0, maxH = 0;
        const allTargets = [];

        this.elements.bars.forEach(bar => {
          const items = getTargets(bar);
          items.forEach(el => {
            const rect = el.getBoundingClientRect();
            if (rect.width > maxW) maxW = rect.width;
            if (rect.height > maxH) maxH = rect.height;
            allTargets.push({ el, bar });
          });
        });

        this.elements.bars.forEach(bar => {
          const pill = qs('.vh-hover-pill', bar);
          if (!pill) return;

          const isRight = bar.classList.contains('vh-bar--right');
          const padX = isRight ? 5 : 32; 
          
          pill.style.width = `${Math.ceil(maxW + padX)}px`;
          pill.style.height = `${Math.ceil(maxH + 18)}px`;

          const targets = allTargets.filter(t => t.bar === bar).map(t => t.el);
          
          targets.forEach(target => {
            const move = () => {
              const barRect = bar.getBoundingClientRect();
              const itemRect = target.getBoundingClientRect();
              
              const x = (itemRect.left - barRect.left) + (itemRect.width - parseFloat(pill.style.width)) / 2;
              const y = (itemRect.top - barRect.top) + (itemRect.height - parseFloat(pill.style.height)) / 2;
              
              raf(() => {
                pill.style.transform = `translate(${x}px, ${y}px)`;
                pill.style.opacity = '1';
              });
            };

            target.addEventListener('mouseenter', move);
            target.addEventListener('focus', move);
            this.state.cleanupFns.push(() => {
              target.removeEventListener('mouseenter', move);
              target.removeEventListener('focus', move);
            });
          });

          const hide = () => pill.style.opacity = '0';
          bar.addEventListener('mouseleave', hide);
          this.state.cleanupFns.push(() => bar.removeEventListener('mouseleave', hide));
        });
      };

      syncPills();
      const ro = new ResizeObserver(() => raf(syncPills));
      this.elements.bars.forEach(b => ro.observe(b));
      this.state.observers.push(ro);
    }

    // ============================================================
    // 4. Locale Dropdown (Restored Original Logic)
    // ============================================================
    initLocale() {
      const instances = [
        { triggerSel: '[data-vh-locale-trigger="desktop"]', menuId: '#vh-locale-menu-desktop', formId: '#vh-locale-desktop-form', mode: 'hover' },
        { triggerSel: '[data-vh-locale-trigger="mobile"]', menuId: '#vh-locale-menu-mobile', formId: '#vh-locale-mobile-form', mode: 'click' }
      ];

      instances.forEach(config => {
        const trigger = qs(config.triggerSel, this.root);
        const menu = qs(config.menuId, this.root);
        const form = qs(config.formId, this.root);
        
        if (!trigger || !menu || !form) return;

        const btns = qsa('.vh-locale-menu__btn', menu);
        let closeTimer;

        // --- CORE LOGIC (Restored from your V1) ---
        const open = () => {
          clearTimeout(closeTimer);
          menu.classList.add('is-open');
        };

        const close = () => {
          closeTimer = setTimeout(() => menu.classList.remove('is-open'), 150);
        };

        const toggle = (e) => {
            // THE NUCLEAR OPTION (Restored)
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            if (menu.classList.contains('is-open')) {
                menu.classList.remove('is-open');
            } else {
                // Close other open menus first
                qsa('.vh-locale-menu.is-open').forEach(m => m.classList.remove('is-open'));
                open();
            }
        };

        // --- BINDING ---
        if (config.mode === 'hover') {
            trigger.addEventListener('mouseenter', open);
            trigger.addEventListener('mouseleave', close);
            menu.addEventListener('mouseenter', open);
            menu.addEventListener('mouseleave', close);
        } else {
            // Mobile: Click (Isolated)
            const actualClickTarget = trigger.querySelector('.vh-locale-chip') || trigger;
            actualClickTarget.addEventListener('click', toggle);
        }

        // Button Logic
        btns.forEach(btn => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const input = qs('input[name="locale_code"]', form);
            if (input) input.value = btn.value;
            form.submit();
          });
        });
      });
      
      // Global "Click Outside" to close dropdowns
      // (This only fires if stopPropagation wasn't called)
      document.addEventListener('click', (e) => {
         qsa('.vh-locale-menu.is-open').forEach(menu => {
             const id = menu.id;
             const isDesktop = id.includes('desktop');
             const triggerAttr = isDesktop ? 'desktop' : 'mobile';
             const trigger = qs(`[data-vh-locale-trigger="${triggerAttr}"]`);
             
             if (!menu.contains(e.target) && !trigger.contains(e.target)) {
                 menu.classList.remove('is-open');
             }
         });
      });
    }
    
    // ============================================================
    // 5. Cart Listener & Announcement Offset
    // ============================================================
    initCartListener() {
      const updateCart = (e) => {
        const count = e.detail?.count ?? e.detail?.cart?.item_count;
        if (count === undefined) return;

        this.root.setAttribute('data-cart-count', count);
        const badges = qsa('.vh-cart-badge', this.root);
        badges.forEach(b => {
            b.textContent = count > 99 ? '99+' : count;
            b.hidden = count === 0;
        });
      };
      
      window.addEventListener('cart:updated', updateCart);
      window.addEventListener('vh:cart-count', updateCart);
      this.state.cleanupFns.push(() => {
        window.removeEventListener('cart:updated', updateCart);
        window.removeEventListener('vh:cart-count', updateCart);
      });
    }

    initAnnouncementOffset() {
      const getBar = () => qs(this.settings.announceSel);
      
      const measure = () => {
        const bar = getBar();
        const h = bar ? bar.getBoundingClientRect().height : 0;
        this.announcementHeight = h;
        onScroll(); 
      };

      const onScroll = () => {
        const y = window.scrollY || 0;
        const h = this.announcementHeight || 0;
        const safeY = Math.max(0, y);
        const newOffset = Math.max(0, h - safeY);
        this.root.style.setProperty('--vh-announcement-offset', `${newOffset}px`);
      };

      const bar = getBar();
      if (bar && window.ResizeObserver) {
        const ro = new ResizeObserver(() => raf(measure));
        ro.observe(bar);
        this.state.observers.push(ro);
      }
      
      window.addEventListener('resize', () => raf(measure), { passive: true });
      window.addEventListener('scroll', () => raf(onScroll), { passive: true });
      
      measure();
    }
    
    // ============================================================
    // 6. Focus Hygiene
    // ============================================================
    initFocusHygiene() {
      let isPointer = false;
      const setPointer = () => { isPointer = true; };
      ['mousedown', 'touchstart'].forEach(ev => 
          this.root.addEventListener(ev, setPointer, { passive: true })
      );

      this.root.addEventListener('focusin', (e) => {
          if (isPointer) {
            const el = e.target;
            if (el.tagName !== 'INPUT' && el.tagName !== 'TEXTAREA') {
                el.blur();
            }
            isPointer = false;
          }
      });
    }

    destroy() {
        this.state.observers.forEach(o => o.disconnect());
        this.state.cleanupFns.forEach(fn => fn());
    }
  }

  // ============================================================
  // Bootstrapping
  // ============================================================
  const map = new WeakMap();

  const load = (root) => {
    if (map.has(root)) return;
    const instance = new VividHeader(root);
    map.set(root, instance);
  };

  const unload = (root) => {
    if (!map.has(root)) return;
    map.get(root).destroy();
    map.delete(root);
  };

  document.addEventListener('DOMContentLoaded', () => {
    qsa('.vh-header').forEach(load);
  });

  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.classList.contains('vh-header')) load(e.target);
    else qsa('.vh-header', e.target).forEach(load);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    if (e.target.classList.contains('vh-header')) unload(e.target);
    else qsa('.vh-header', e.target).forEach(unload);
  });

})();

/* =========================================================
   VIVID — V1 Product Display (Controller)
   Standard: v2.0
   Scope: [data-section="v1-product-display"]
   ========================================================= */

(function () {
  'use strict';

  const SELECTOR = '[data-section="v1-product-display"]';
  const REGISTRY = new WeakMap();

  class ProductDisplay {
    constructor(root) {
      this.root = root;
      this.cards = root.querySelectorAll('.vh-prod-card');
      this.grid = root.querySelector('.vh-products__grid');
      this.dots = root.querySelectorAll('.vh-products__dot');
      
      // State & Observers
      this.observers = [];
      this.cleanupFns = [];
      this.isRTL = document.documentElement.getAttribute('dir') === 'rtl';

      this.init();
    }

    init() {
      if (!this.cards.length) return;

      this.setupCardClicks();
      this.setupVideoPerformance();
      this.setupMobileNavigation();
    }

    /**
     * 1. Clickable Card Pattern
     * Makes the entire card clickable if a primary CTA exists,
     * but ignores clicks on other interactive elements.
     */
    setupCardClicks() {
      this.cards.forEach((card) => {
        const cta = card.querySelector('.vh-cta');
        // Abort if no valid CTA found or it's disabled
        if (!cta || cta.getAttribute('aria-disabled') === 'true') {
          return;
        }

        const handleClick = (e) => {
          // 1. Allow text selection
          if (window.getSelection().toString().length > 0) return;

          // 2. Ignore clicks on nested interactive elements
          if (e.target.closest('a, button, input, label, select, textarea') && e.target !== cta) {
            return;
          }

          // 3. Prevent infinite loop if clicking the CTA itself
          if (e.target === cta) return;

          // 4. Trigger the click
          e.preventDefault();
          cta.click();
        };

        card.style.cursor = 'pointer';
        card.addEventListener('click', handleClick);
        this.cleanupFns.push(() => {
          card.removeEventListener('click', handleClick);
          card.style.cursor = '';
        });
      });
    }

    /**
     * 2. Video Performance (Updated)
     * - Desktop: Play on Hover, Pause on Leave.
     * - Mobile: Play when scrolled into view (Autoplay behavior).
     * - Global: Pause when scrolled out of view.
     */
    setupVideoPerformance() {
      const videos = this.root.querySelectorAll('video');
      if (!videos.length) return;

      const isMobile = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
      const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // A. Desktop Hover Logic
      if (!isMobile && !prefersReduced) {
        videos.forEach((video) => {
          const card = video.closest('.vh-prod-card');
          if (!card) return;

          const onEnter = () => video.play().catch(() => {});
          const onLeave = () => {
            video.pause();
            video.currentTime = 0; // Optional: Reset to start
          };

          card.addEventListener('mouseenter', onEnter);
          card.addEventListener('mouseleave', onLeave);

          // Cleanup
          this.cleanupFns.push(() => {
            card.removeEventListener('mouseenter', onEnter);
            card.removeEventListener('mouseleave', onLeave);
          });
        });
      }

      // B. Scroll Visibility Logic (Mobile Autoplay + Global Optimize)
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          
          if (!entry.isIntersecting) {
            // Always pause if off screen
            video.pause();
          } else if (isMobile && !prefersReduced) {
            // Mobile: Simulate "Autoplay" when visible
            video.play().catch(() => {});
          }
        });
      }, { threshold: 0.5 }); // 50% visible before playing on mobile

      videos.forEach((video) => observer.observe(video));
      this.observers.push(observer);
    }

    /**
     * 3. Mobile Navigation (Dots & Scroll Sync)
     * Handles the scroll snapping logic and active dot state.
     * Includes RTL support and resize listeners.
     */
    setupMobileNavigation() {
      if (!this.grid || !this.dots.length) return;

      const mediaQuery = window.matchMedia('(max-width: 768px)');
      
      const handleScroll = () => {
        // Debounce slightly for performance
        if (this.scrollTicking) return;
        this.scrollTicking = true;
        
        requestAnimationFrame(() => {
          this.updateActiveDot();
          this.scrollTicking = false;
        });
      };

      const mountMobile = () => {
        this.grid.addEventListener('scroll', handleScroll, { passive: true });
        this.updateActiveDot(); // Initial check
      };

      const unmountMobile = () => {
        this.grid.removeEventListener('scroll', handleScroll);
      };

      // Listener for screen resize (Mount/Unmount logic)
      const handleResize = (e) => {
        if (e.matches) mountMobile();
        else unmountMobile();
      };

      // Initial Mount
      if (mediaQuery.matches) mountMobile();
      
      // Bind Listener
      mediaQuery.addEventListener('change', handleResize);
      this.cleanupFns.push(() => mediaQuery.removeEventListener('change', handleResize));
      
      // Cleanup Scroll Listener explicitly on destroy
      this.cleanupFns.push(unmountMobile);

      // Bind Dot Clicks (Always active, just hidden on desktop via CSS)
      this.dots.forEach((dot, index) => {
        const onDotClick = () => {
          const card = this.cards[index];
          if (!card) return;

          // RTL Aware Scroll Calculation
          const gridWidth = this.grid.clientWidth;
          const cardWidth = card.clientWidth;
          const cardLeft = card.offsetLeft;
          
          let targetPos;

          if (this.isRTL) {
             // In RTL, scrollLeft is negative or inverted depending on browser engine
             // Safest to use scrollIntoView for RTL complexity
             card.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
          } else {
             targetPos = cardLeft - (gridWidth / 2) + (cardWidth / 2);
             this.grid.scrollTo({ left: targetPos, behavior: 'smooth' });
          }
        };

        dot.addEventListener('click', onDotClick);
        this.cleanupFns.push(() => dot.removeEventListener('click', onDotClick));
      });
    }

    updateActiveDot() {
      const center = this.grid.scrollLeft + (this.grid.clientWidth / 2);
      let closestIndex = 0;
      let minDistance = Infinity;

      this.cards.forEach((card, index) => {
        const cardCenter = card.offsetLeft + (card.clientWidth / 2);
        const distance = Math.abs(center - cardCenter);

        if (distance < minDistance) {
          minDistance = distance;
          closestIndex = index;
        }
      });

      this.dots.forEach((dot, index) => {
        if (index === closestIndex) {
          dot.classList.add('is-active');
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.classList.remove('is-active');
          dot.removeAttribute('aria-current');
        }
      });
    }

    destroy() {
      // 1. Disconnect Observers
      this.observers.forEach((obs) => obs.disconnect());
      
      // 2. Run Cleanup Functions (Listeners)
      this.cleanupFns.forEach((fn) => fn());
      
      // 3. Reset State
      this.observers = [];
      this.cleanupFns = [];
    }
  }

  // =========================================================
  // Lifecycle Management (Shopify Theme Editor Safe)
  // =========================================================

  const init = (root) => {
    if (!root || REGISTRY.has(root)) return;
    REGISTRY.set(root, new ProductDisplay(root));
  };

  const teardown = (root) => {
    const instance = REGISTRY.get(root);
    if (instance) {
      instance.destroy();
      REGISTRY.delete(root);
    }
  };

  // 1. Global Load
  document.querySelectorAll(SELECTOR).forEach(init);

  // 2. Theme Editor Events
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.matches(SELECTOR)) init(e.target);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    if (e.target.matches(SELECTOR)) teardown(e.target);
  });

})();

/* ==========================================
   Append to: assets/vh.js
   Section: V1 Sub-Splash
   Hook: [data-section="v1-sub-splash"]
   Responsibilities:
     - Make disabled CTAs inert (no href, aria-disabled, tabindex=-1)
     - Theme Editor lifecycle (load/unload)
     - Minimal footprint; no globals leaked
   ========================================== */

(function() {
  const init = (root) => {
    if (!root || !root.matches('.vh-sub-splash')) return;
    if (root.dataset.vhInited === '1') return;
    root.dataset.vhInited = '1';
    // Interactive logic here
  };

  const teardown = (root) => {
    if (!root || !root.matches('.vh-sub-splash')) return;
    delete root.dataset.vhInited;
    // Disconnect observers, remove listeners here
  };

  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:unload', (e) => teardown(e.target));
  document.querySelectorAll('.vh-sub-splash').forEach(init);
})();

/* === VH — Capsule Tech (Fix: Mobile Spacing & No-Double Dots) === */
(function() {
  const SECTION_KEY = 'vh-capsule-tech';
  const SELECTOR = `[data-section="${SECTION_KEY}"]`;

  function init(root) {
    if (!root || root._vhCtInited) return;
    root._vhCtInited = true;

    const card = root.querySelector('.vh-capsule-tech__card');
    const mediaCol = root.querySelector('.vh-capsule-tech__right');
    const videoWrap = root.querySelector('.vh-ct-video-wrap');
    const videoEl = root.querySelector('.vh-ct-video');
    const callouts = Array.from(root.querySelectorAll('.vh-ct-callout'));
    const anchors = Array.from(root.querySelectorAll('.vh-ct-anchor'));
    
    // Environment
    const mqlMobile = window.matchMedia('(max-width: 767px)');
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoplay = root.dataset.autoplay === 'true';

    // 1. Setup SVG
    const SVG_NS = 'http://www.w3.org/2000/svg';
    let wires = root.querySelector('.vh-ct-wires-container svg');
    if (!wires) {
      const container = root.querySelector('.vh-ct-wires-container');
      if (container) {
        wires = document.createElementNS(SVG_NS, 'svg');
        wires.setAttribute('aria-hidden', 'true');
        wires.style.width = '100%';
        wires.style.height = '100%';
        container.appendChild(wires);
      }
    }

    // 2. Map Anchors
    const anchorMap = {};
    anchors.forEach(a => {
      const key = Array.from(a.classList).find(c => c.startsWith('vh-ct-anchor--'));
      if (key) anchorMap['.' + key] = a;
    });

    // 3. Layout Logic
    function layoutCallouts() {
      if (!mediaCol || !wires) return;

      const mediaRect = mediaCol.getBoundingClientRect();
      const mobile = mqlMobile.matches;

      const K = {
        BASE_SPREAD: mobile ? 0 : Math.min(140, mediaRect.height * 0.22),
        DOT_RADIUS: 3,
        JITTER_MAX: (prefersReduced || mobile) ? 0 : 36
      };

      // Clear SVG
      while (wires.firstChild) wires.removeChild(wires.firstChild);
      
      const plans = [];
      
      // A. Calculate Positions
      if (mobile) {
        // FIXED: Reduced start gap and item gap for tighter mobile feel
        let cursorY = 0; 
        const gap = 12; // Tighter gap (was 16)
        
        callouts.forEach(co => {
          const h = co.getBoundingClientRect().height || 40;
          const topPx = Math.min(cursorY, mediaRect.height - h);
          cursorY = topPx + h + gap;
          plans.push({ co, topPx, mobile: true });
        });
      } else {
        callouts.forEach((co, i) => {
          const anchorSel = co.getAttribute('data-anchor');
          const anchor = anchorMap[anchorSel];
          if (!anchor) return;

          const aRect = anchor.getBoundingClientRect();
          const coRect = co.getBoundingClientRect();
          
          let topPx = (aRect.top + aRect.height/2) - mediaRect.top - (coRect.height/2);
          
          const variant = co.getAttribute('data-variant');
          const offset = parseFloat(co.getAttribute('data-offset')) || 0;
          const jitter = Math.sin((i+1) * 1.7) * K.JITTER_MAX;

          if (variant === 'top') topPx -= (K.BASE_SPREAD + jitter);
          if (variant === 'bottom') topPx += (K.BASE_SPREAD + jitter);
          
          topPx += offset;
          topPx = Math.max(0, Math.min(mediaRect.height - coRect.height, topPx));
          
          plans.push({ co, anchor, topPx, mobile: false, side: co.getAttribute('data-side') });
        });
      }

      // B. Apply Positions & Draw
      plans.forEach(p => {
        p.co.style.top = `${p.topPx}px`;
        
        const coRect = p.co.getBoundingClientRect();
        const startY = (coRect.top + coRect.height/2) - mediaRect.top;
        
        if (p.mobile) {
          // FIXED: Mobile Wire starts at RIGHT edge of text, not left.
          const videoRect = videoWrap ? videoWrap.getBoundingClientRect() : null;
          if (!videoRect) return;
          
          const startX = (coRect.right - mediaRect.left) + 8; // Start 8px after text ends
          const endX = (videoRect.left - mediaRect.left) - 8; // End before video
          
          if (endX > startX) {
            // Draw Line
            const path = document.createElementNS(SVG_NS, 'path');
            path.setAttribute('d', `M ${startX} ${startY} H ${endX}`);
            wires.appendChild(path);
            
            // Draw Dot at Video End
            const circle = document.createElementNS(SVG_NS, 'circle');
            circle.setAttribute('cx', endX);
            circle.setAttribute('cy', startY);
            circle.setAttribute('r', K.DOT_RADIUS);
            wires.appendChild(circle);
          }
          
        } else {
          // Desktop Wire (Elbow)
          const aRect = p.anchor.getBoundingClientRect();
          const endY = (aRect.top + aRect.height/2) - mediaRect.top;
          const side = p.side;
          
          const padX = side === 'left' 
            ? parseFloat(getComputedStyle(p.co).paddingRight) 
            : parseFloat(getComputedStyle(p.co).paddingLeft);
            
          const startX = side === 'left'
            ? (coRect.right - padX - mediaRect.left)
            : (coRect.left + padX - mediaRect.left);
            
          const endX = side === 'left'
            ? (aRect.left - mediaRect.left) + K.DOT_RADIUS
            : (aRect.right - mediaRect.left) - K.DOT_RADIUS;

          const midX = startX + (endX - startX) * 0.5;
          const d = `M ${startX} ${startY} L ${midX} ${startY} L ${midX} ${endY} L ${endX} ${endY}`;
          
          const path = document.createElementNS(SVG_NS, 'path');
          path.setAttribute('d', d);
          wires.appendChild(path);

          const circle = document.createElementNS(SVG_NS, 'circle');
          circle.setAttribute('cx', endX);
          circle.setAttribute('cy', endY);
          circle.setAttribute('r', K.DOT_RADIUS);
          wires.appendChild(circle);
        }
      });
      
      // C. Mobile Video Vertical Alignment
      if (mobile && videoWrap && plans.length > 1) {
        const first = plans[0].topPx;
        const last = plans[plans.length-1].topPx + 40; 
        const mid = (first + last) / 2;
        const vH = videoWrap.offsetHeight;
        videoWrap.style.marginTop = `${Math.max(0, mid - vH/2)}px`;
      } else {
        videoWrap.style.marginTop = '';
      }
    }

    // 4. Observers
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          card.classList.add('is-visible');
          if (videoEl && autoplay) videoEl.play().catch(()=>{});
          requestAnimationFrame(layoutCallouts);
        } else {
          if (videoEl) videoEl.pause();
        }
      });
    }, { threshold: 0.2 });
    observer.observe(root);
    root._vhIO = observer;

    const resizeObs = new ResizeObserver(() => requestAnimationFrame(layoutCallouts));
    if (mediaCol) resizeObs.observe(mediaCol);
    root._vhRO = resizeObs;

    requestAnimationFrame(layoutCallouts);
  }

  const unload = (root) => {
    if (root._vhIO) root._vhIO.disconnect();
    if (root._vhRO) root._vhRO.disconnect();
    root._vhCtInited = false;
  };

  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.dataset.section === SECTION_KEY) init(e.target);
  });
  document.addEventListener('shopify:section:unload', (e) => {
    if (e.target.dataset.section === SECTION_KEY) unload(e.target);
  });
  
  document.querySelectorAll(SELECTOR).forEach(init);
})();

/* ==========================================
   Append to: assets/vh.js
   Section: VH — Science Splash (scoped) (.vh-science-splash)
   ========================================== */

(function () {
  'use strict';

  // ------------------------------------------------------------
  // Global namespace (idempotent)
  // ------------------------------------------------------------
  window.VH = window.VH || {
    modules: new Map(),
    register: function register(name, factory) {
      if (!this.modules.has(name)) this.modules.set(name, factory);
    }
  };

  // ------------------------------------------------------------
  // Utils
  // ------------------------------------------------------------
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var raf = function (fn) { return requestAnimationFrame(fn); };

  // ------------------------------------------------------------
  // Shared: Inert disabled anchors (.vh-cta.is-disabled)
  // ------------------------------------------------------------
  function inertAnchors(root) {
    var scope = root || document;
    scope.querySelectorAll('.vh-cta.is-disabled').forEach(function (el) {
      if (el.dataset._inert) return;
      el.dataset._inert = '1';
      el.removeAttribute('href');
      el.setAttribute('aria-disabled', 'true');
      el.tabIndex = -1;

      var stop = function (e) { e.preventDefault(); e.stopPropagation(); };
      el.addEventListener('click', stop, { passive: false });
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') stop(e);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { inertAnchors(document); }, { once: true });
  } else {
    inertAnchors(document);
  }

  // ------------------------------------------------------------
  // Section module: vh-science-splash — init/teardown
  // ------------------------------------------------------------
  VH.register('vh-science-splash', function init(sectionEl) {
    var destroyFns = [];
    var observed = [];

    function applyInview(targets) {
      raf(function () {
        targets.forEach(function (el) { el.classList.add('is-inview'); });
      });
    }

    var targets = [sectionEl].concat(Array.from(
      sectionEl.querySelectorAll('.vh-science-splash__media-inner, .vh-science-splash__title, .vh-science-splash__sub')
    ));

    if (prefersReducedMotion) {
      applyInview(targets);
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            applyInview([entry.target]);
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.2 });

      targets.forEach(function (t) { io.observe(t); observed.push(t); });
      destroyFns.push(function () { io.disconnect(); observed = []; });
    }

    // Ensure disabled CTAs inside this section are inert
    inertAnchors(sectionEl);

    // Return teardown
    return function teardown() {
      destroyFns.forEach(function (fn) { try { fn(); } catch (e) {} });
      destroyFns = [];
    };
  });

  // ------------------------------------------------------------
  // Bootstrap instances + Shopify Theme Editor lifecycle
  // ------------------------------------------------------------
  var instances = new WeakMap();

  function mount(root) {
    (root || document).querySelectorAll('.vh-science-splash').forEach(function (el) {
      if (instances.has(el)) return;
      var init = VH.modules.get('vh-science-splash');
      if (!init) return;
      var teardown = init(el) || function () {};
      instances.set(el, teardown);
    });
  }

  function unmount(root) {
    (root || document).querySelectorAll('.vh-science-splash').forEach(function (el) {
      var teardown = instances.get(el);
      if (teardown) {
        try { teardown(); } catch (e) {}
        instances.delete(el);
      }
    });
  }

  // Initial mount
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { mount(document); }, { once: true });
  } else {
    mount(document);
  }

  // Theme Editor events
  document.addEventListener('shopify:section:load', function (e) {
    inertAnchors(e.target);
    mount(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    unmount(e.target);
  });
})();

/* =======================================================================
   VIVID — DUO PANELS
   ======================================================================= */

(function() {
  const init = (root) => {
    if (!root) return;
    
    // Smooth image loading implementation
    const images = root.querySelectorAll('img.vh-image-smooth');
    images.forEach(img => {
      if (img.complete) {
        img.classList.add('is-loaded');
      } else {
        img.addEventListener('load', () => img.classList.add('is-loaded'), { once: true });
        img.addEventListener('error', () => img.classList.add('is-loaded'), { once: true }); // Fail gracefully
      }
    });
  };

  const teardown = (root) => {
    // No persistent listeners to disconnect for this specific component
  };

  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.classList.contains('vh-duo-panels')) {
      init(e.target);
    }
  });
  
  document.addEventListener('shopify:section:unload', (e) => {
    if (e.target.classList.contains('vh-duo-panels')) {
      teardown(e.target);
    }
  });

  document.querySelectorAll('.vh-duo-panels').forEach(init);
})();

/* =======================================================================
   VIVID — PDP (FINAL) JS — CLEANED
   Scope: sections/vh-product.liquid  (root: [data-vh="vh-product"])
   ======================================================================= */
(() => {
  const ROOT_SELECTOR = '[data-vh="vh-product"]';
  const INSTANCES = new WeakMap();

  /* ----------------- tiny helpers ----------------- */
  const $  = (root, s) => root.querySelector(s);
  const $$ = (root, s) => Array.from(root.querySelectorAll(s));
  const on = (el, type, fn, opts) => { el && el.addEventListener(type, fn, opts); return () => el && el.removeEventListener(type, fn, opts); };
  const raf = (fn) => requestAnimationFrame(fn);

  /* ----------------- sticky offset under header ----------------- */
  function getHeaderHeight() {
    const candidates = [
      '#shopify-section-header',
      '.shopify-section-header',
      'header.header',
      'header.site-header',
      '.sticky-header',
      '[data-sticky-header]',
      '[data-header]'
    ];

    let maxH = 0;
    candidates.forEach(sel => {
      const el = document.querySelector(sel);
      if (!el) return;
      const rect = el.getBoundingClientRect();
      maxH = Math.max(maxH, rect.height || el.offsetHeight || 0);
    });
    return maxH;
  }

  function setStickyTop(root) {
    const top = Math.max(8, Math.round(getHeaderHeight()) + 8);
    root.style.setProperty('--stickyTop', `${top}px`);
  }

  /* ----------------- accordions ----------------- */
  function initAccordions(root, bag) {
    const wrap = root.querySelector('[data-accordion]');
    if (!wrap) return;

    $$(wrap, '.vh-acc__item').forEach(item => {
      const btn = item.querySelector('.vh-acc__t');
      const panel = item.querySelector('.vh-acc__p');
      if (!btn || !panel) return;

      // default closed
      btn.setAttribute('aria-expanded', 'false');
      panel.hidden = true;

      let lock = false;
      const toggle = (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation?.();
        if (lock) return;
        lock = true;

        const open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        panel.hidden = open;

        requestAnimationFrame(() => { lock = false; });
      };


      bag.cleanups.push(on(btn, 'click', toggle));
      // keyboard coverage if markup ever morphs away from <button>
      bag.cleanups.push(on(btn, 'keydown', (e) => {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); btn.click(); }
      }));
    });
  }

  /* ----------------- bundles + quantity sync ----------------- */
  function initControls(root, bag) {
    const chips      = $$(root, '.vh-qchip');               // 2 chips expected
    const qtyInput   = root.querySelector('.quantity__input');
    const minusBtn   = root.querySelector('.quantity__button[name="minus"]');
    const plusBtn    = root.querySelector('.quantity__button[name="plus"]');

    // hidden line item props (optional)
    const modeProp   = root.querySelector('[data-bundle-mode-prop]'); // "single" | "bundle" (compat)
    const bundleProp = root.querySelector('[data-bundle-prop]');      // "5-pack" | "10-pack" | ""

    // thresholds + labels (from data-*)
    const th1  = Number(root.dataset.bundleTh1 || 0) || 0;
    const th2  = Number(root.dataset.bundleTh2 || 0) || 0;
    const lab1 = root.dataset.bundleLabel1 || '';
    const lab2 = root.dataset.bundleLabel2 || '';

    // helpers
    const setQty = (n) => {
      if (!qtyInput) return;
      const v = Math.max(1, Number(n) || 1);
      qtyInput.value = String(v);
      // fire both to satisfy any theme listeners
      qtyInput.dispatchEvent(new Event('input',  { bubbles: true }));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const setMode        = (m)    => { if (modeProp)   modeProp.value   = m; };
    const setBundleLabel = (lbl)  => { if (bundleProp) bundleProp.value = lbl || ''; };

    const activateChip = (chip) => {
      chips.forEach(c => {
        const on = c === chip;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-pressed', String(on));
      });
    };
    const clearChips = () => chips.forEach(c => { c.classList.remove('is-active'); c.setAttribute('aria-pressed','false'); });

    // Which bundle applies for qty?
    function bundleForQty(v) {
      const n = Number(v) || 0;
      if (th2 > 0 && n >= th2) {
        const chip = chips.find(c => Number(c.dataset.q) === th2) || null;
        return { label: lab2, chip };
      }
      if (th1 > 0 && n >= th1 && (th2 === 0 || n < th2)) {
        const chip = chips.find(c => Number(c.dataset.q) === th1) || null;
        return { label: lab1, chip };
      }
      return null;
    }

    // Sync UI + hidden props from current qty
    function syncFromQty() {
      const v = Number(qtyInput?.value || 0);
      const b = bundleForQty(v);

      if (b) {
        setBundleLabel(b.label);
        setMode('bundle');
        b.chip ? activateChip(b.chip) : clearChips();
      } else {
        setBundleLabel('');
        setMode('single');
        clearChips();
      }
    }

    // Chip clicks → set qty to threshold; qty listeners will sync
    chips.forEach(chip => {
      chip.setAttribute('role', 'button');
      chip.setAttribute('aria-pressed', 'false');
      bag.cleanups.push(on(chip, 'click', (e) => {
        e.preventDefault();
        const q = Number(chip.dataset.q || 0);
        if (q > 0) setQty(q);
      }));
      bag.cleanups.push(on(chip, 'keydown', (e) => {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); chip.click(); }
      }));
    });

    if (qtyInput) {
      const handler = () => syncFromQty();
      bag.cleanups.push(on(qtyInput, 'input', handler));
      bag.cleanups.push(on(qtyInput, 'change', handler));
    }
    if (minusBtn) bag.cleanups.push(on(minusBtn, 'click', () => setTimeout(syncFromQty, 0)));
    if (plusBtn)  bag.cleanups.push(on(plusBtn,  'click', () => setTimeout(syncFromQty, 0)));

    // initial state
    syncFromQty();
  }


  /* ----------------- init / teardown ----------------- */
  function init(root) {
    if (!root || INSTANCES.has(root)) return;
    const bag = { cleanups: [] };

    // sticky offset under header (reacts to resizes/font loads)
    const updateSticky = () => setStickyTop(root);
    const onResize = () => raf(updateSticky);
    updateSticky();

    bag.cleanups.push(on(window, 'resize', onResize, { passive: true }));
    bag.cleanups.push(on(window, 'orientationchange', onResize));

    if (document.fonts?.ready?.then) {
      document.fonts.ready.then(() => raf(updateSticky)).catch(() => {});
    }

    const hdr = document.querySelector('#shopify-section-header, .shopify-section-header') || null;
    if ('ResizeObserver' in window && hdr) {
      const ro = new ResizeObserver(() => raf(updateSticky));
      ro.observe(hdr);
      bag.cleanups.push(() => ro.disconnect());
    }

    // features
    initAccordions(root, bag);
    initControls(root, bag);

    INSTANCES.set(root, bag);
  }

  function destroy(root) {
    const bag = INSTANCES.get(root);
    if (!bag) return;
    bag.cleanups.forEach(fn => { try { fn && fn(); } catch {} });
    INSTANCES.delete(root);
  }

  /* ----------------- bootstrap + Theme Editor ----------------- */
  function bootAll() { document.querySelectorAll(ROOT_SELECTOR).forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll, { once: true });
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const el = e.target?.matches?.(ROOT_SELECTOR) ? e.target : e.target?.querySelector?.(ROOT_SELECTOR);
    if (el) init(el);
  });
  document.addEventListener('shopify:section:unload', (e) => {
    const el = e.target?.matches?.(ROOT_SELECTOR) ? e.target : e.target?.querySelector?.(ROOT_SELECTOR);
    if (el) destroy(el);
  });
})();

/* vh-cart-items — map data-pad-* → CSS vars (no inline styles) */
(() => {
  const SEL = '[data-section="vh-cart-items"]';
  function setPadVars(el){
    if (!el) return;
    const top = parseInt(el.dataset.padTop || '28', 10);
    const bot = parseInt(el.dataset.padBottom || '16', 10);
    el.style.setProperty('--vh-pad-top', `${Math.max(0, top)}px`);
    el.style.setProperty('--vh-pad-bottom', `${Math.max(0, bot)}px`);
  }
  function initAll(){ document.querySelectorAll(SEL).forEach(setPadVars); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', e => {
    if (e.target?.matches?.(SEL)) setPadVars(e.target);
    const inner = e.target?.querySelector?.(SEL);
    if (inner) setPadVars(inner);
  });
})();

/* ====================================================================== */
/* VH — Information Explorer (JS)                                         */
/* Logic: V2 Advanced Engine (Debounced Click + block-size animation)     */
/* ====================================================================== */
(() => {
  'use strict';

  const SELECTOR = '[data-section="vh-information"]';
  const REGISTRY = new WeakMap();

  class VHInformation {
    constructor(root) {
      this.root = root;
      this.accordion = root.querySelector('.vh-information__accordion');
      if (!this.accordion) return;

      this.allowMultiple = String(this.accordion.dataset.allowMultiple) !== 'false';
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.toggles = Array.from(this.root.querySelectorAll('.vh-information__toggle'));
      this.panels = new Map();
      this.toggleLocks = new WeakMap();

      // Bindings
      this.onToggleClick = this.onToggleClick.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);

      // Initialize
      this.toggles.forEach((btn) => {
        const id = btn.getAttribute('aria-controls');
        const panel = id && this.root.querySelector(`#${CSS.escape(id)}`);
        if (!panel) return;
        
        this.panels.set(btn, panel);
        btn.addEventListener('click', this.onToggleClick);
        btn.addEventListener('keydown', this.onKeyDown);
        
        // Ensure clean state
        panel.style.blockSize = '';
      });
    }

    destroy() {
      this.toggles.forEach((btn) => {
        btn.removeEventListener('click', this.onToggleClick);
        btn.removeEventListener('keydown', this.onKeyDown);
      });
      this.panels.forEach((panel) => this.stopAnimation(panel, true));
      this.panels.clear();
    }

    // --- Actions ---

    onToggleClick(e) {
      // 1. Prevent bubbling & default behavior
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation?.();

      // 2. Ignore Detail 0 (Enter key handled by Keydown)
      if (e.detail === 0) return;

      const btn = e.currentTarget;

      // 3. Debounce Lock (Prevents double-fire)
      if (this.toggleLocks.get(btn)) return;
      
      this.toggleLocks.set(btn, true);
      this.toggle(btn);

      // Release lock after animation
      setTimeout(() => {
        this.toggleLocks.set(btn, false);
      }, 350);
    }

    onKeyDown(e) {
      const key = e.key;
      if (!['ArrowDown', 'ArrowUp', 'Home', 'End', 'Enter', ' '].includes(key)) return;

      const btn = e.currentTarget;
      
      if (key === 'Enter' || key === ' ') {
        e.preventDefault();
        btn.click();
        return;
      }

      const idx = this.toggles.indexOf(btn);
      e.preventDefault();
      
      let nextIndex = idx;
      if (key === 'ArrowDown') nextIndex = (idx + 1) % this.toggles.length;
      if (key === 'ArrowUp') nextIndex = (idx - 1 + this.toggles.length) % this.toggles.length;
      if (key === 'Home') nextIndex = 0;
      if (key === 'End') nextIndex = this.toggles.length - 1;
      
      this.toggles[nextIndex]?.focus();
    }

    toggle(btn, forceOpen = undefined) {
      const panel = this.panels.get(btn);
      if (!panel) return;

      const isOpen = btn.getAttribute('aria-expanded') === 'true';
      const nextOpen = forceOpen !== undefined ? forceOpen : !isOpen;
      
      if (nextOpen === isOpen) return;

      if (nextOpen) {
        if (!this.allowMultiple) {
          this.toggles.forEach((other) => {
            if (other !== btn && other.getAttribute('aria-expanded') === 'true') {
              this.collapse(other, this.panels.get(other));
            }
          });
        }
        this.expand(btn, panel);
      } else {
        this.collapse(btn, panel);
      }
    }

    expand(btn, panel) {
      btn.setAttribute('aria-expanded', 'true');
      panel.hidden = false;

      if (this.reducedMotion) {
        panel.style.blockSize = '';
        return;
      }
      this.animate(panel, { from: 0, to: panel.scrollHeight, clearOnEnd: true });
    }

    collapse(btn, panel) {
      btn.setAttribute('aria-expanded', 'false');

      if (this.reducedMotion) {
        panel.hidden = true;
        panel.style.blockSize = '';
        return;
      }
      
      const current = panel.scrollHeight;
      this.animate(panel, {
        from: current,
        to: 0,
        onFinish: () => {
          panel.hidden = true;
          panel.style.blockSize = '';
        }
      });
    }

    animate(panel, { from = 0, to, clearOnEnd = false, onFinish } = {}) {
      this.stopAnimation(panel);

      const controller = new AbortController();
      panel._vhAbort = controller;

      requestAnimationFrame(() => {
        if (controller.signal.aborted) return;

        panel.style.blockSize = `${from}px`;
        // Force Reflow
        // eslint-disable-next-line no-unused-expressions
        panel.offsetHeight;

        const handleEnd = (ev) => {
          if (ev.target !== panel) return;
          // IMPORTANT: Check for block-size OR height to be safe
          if (ev.propertyName !== 'block-size' && ev.propertyName !== 'height') return;
          
          panel.removeEventListener('transitionend', handleEnd);
          if (clearOnEnd) panel.style.blockSize = '';
          if (typeof onFinish === 'function') onFinish();
        };

        panel.addEventListener('transitionend', handleEnd, { signal: controller.signal });
        panel.style.blockSize = `${to}px`;
      });
    }

    stopAnimation(panel, instant = false) {
      if (panel?._vhAbort) {
        panel._vhAbort.abort();
        panel._vhAbort = null;
      }
      if (instant) panel.style.blockSize = '';
    }
  }

  /* ------------------------- Lifecycle ------------------------- */

  const init = (root) => {
    if (!root || REGISTRY.has(root)) return;
    REGISTRY.set(root, new VHInformation(root));
  };

  const destroy = (root) => {
    const inst = REGISTRY.get(root);
    if (inst) {
      inst.destroy();
      REGISTRY.delete(root);
    }
  };

  const initAll = () => document.querySelectorAll(SELECTOR).forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target?.querySelector?.(SELECTOR);
    if (root) init(root);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const root = e.target?.querySelector?.(SELECTOR);
    if (root) destroy(root);
  });
})();

/* === VH — Image Hero (vh-image-hero) === */
(function() {
  const SELECTOR = '.vh-image-hero';
  const IMG_SELECTOR = '.vh-image-hero__img';
  const ACTIVE_CLASS = 'is-loaded';
  
  // Track initialized sections to prevent double-binding
  const registry = new WeakSet();

  // 1. Shared Observer (Performance Optimization)
  // Only create one observer for the entire page
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Optional: Add 'is-inview' class if you want scroll animations later
        entry.target.classList.add('is-inview');
      }
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });

  const init = (section) => {
    if (!section || registry.has(section)) return;
    
    const img = section.querySelector(IMG_SELECTOR);
    
    // A. Handle Image Loading (Fade In)
    if (img) {
      if (img.complete) {
        section.classList.add(ACTIVE_CLASS);
      } else {
        img.addEventListener('load', () => section.classList.add(ACTIVE_CLASS), { once: true });
      }
    } else {
      // Fallback for placeholder
      section.classList.add(ACTIVE_CLASS);
    }

    // B. Register for Viewport Observation
    observer.observe(section);
    registry.add(section);
  };

  const teardown = (section) => {
    if (!section) return;
    observer.unobserve(section);
    registry.delete(section);
  };

  // C. Lifecycle Hooks
  document.addEventListener('shopify:section:load', (e) => {
    const el = e.target.querySelector(SELECTOR);
    if (el) init(el);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const el = e.target.querySelector(SELECTOR);
    if (el) teardown(el);
  });

  // Boot
  document.querySelectorAll(SELECTOR).forEach(init);
})();

/* === VH — VividText (Refactored & Safe) === */
(function() {
  const CSS_PAUSED = 'is-paused';
  const CSS_VISIBLE = 'is-visible';

  // 1. Observer Logic
  const handleIntersection = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const root = entry.target;
        
        // Trigger Animation
        root.classList.add(CSS_VISIBLE);
        
        // Cleanup class (optional, keeps DOM clean)
        // root.classList.remove(CSS_PAUSED); 
        
        observer.unobserve(root);
      }
    });
  };

  // 2. Init Routine
  const init = (root) => {
    if (!root || root.dataset.vhInit) return;
    root.dataset.vhInit = 'true';

    // A11y Check: Abort animation if reduced motion
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // "Capture" the state: Hide it immediately so we can animate it in.
    root.classList.add(CSS_PAUSED);

    // Setup Observer
    const observer = new IntersectionObserver(handleIntersection, {
      root: null,
      threshold: 0.15, 
      rootMargin: '0px 0px -50px 0px'
    });

    observer.observe(root);
    root._vhObserver = observer;
  };

  // 3. Lifecycle Safety
  const teardown = (root) => {
    if (root && root._vhObserver) {
      root._vhObserver.disconnect();
      delete root._vhObserver;
      delete root.dataset.vhInit;
      root.classList.remove(CSS_PAUSED, CSS_VISIBLE);
    }
  };

  // 4. Boot Logic (Fixed Timing)
  const boot = () => {
    document.querySelectorAll('.vh-vividtext').forEach(init);
  };

  // Ensure DOM is ready before querying
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify Theme Editor Hooks
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.classList.contains('vh-vividtext')) init(e.target);
  });
  document.addEventListener('shopify:section:unload', (e) => {
    if (e.target.classList.contains('vh-vividtext')) teardown(e.target);
  });

})();

/* === VH — Deepdive (Fixed Autoplay) =================================== */
(function() {
  const NS = 'vh-deepdive';
  const observers = new WeakMap();

  const init = (root) => {
    if (!root) return;

    const wrapper = root.querySelector('[data-vh-video-wrapper]');
    const video = root.querySelector('video[data-vh-video]');

    if (!wrapper || !video) return;

    const shouldAutoplay = wrapper.dataset.autoplay === 'true';
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReduced) {
      video.pause();
      video.removeAttribute('autoplay');
      return;
    }

    if (shouldAutoplay) {
      // FORCE MUTE: Browsers will block autoplay if this is false
      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            playVideo(video);
          } else {
            pauseVideo(video);
          }
        });
      }, {
        root: null,
        threshold: 0.25
      });

      observer.observe(wrapper);
      observers.set(root, observer);
    }
  };

  const playVideo = (video) => {
    if (!video.paused) return;
    
    // Ensure mute is active right before play attempt
    video.muted = true; 
    
    const playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.catch((e) => {
        console.warn('VH — Autoplay blocked by browser policy:', e);
      });
    }
  };

  const pauseVideo = (video) => {
    if (!video.paused) video.pause();
  };

  const unload = (root) => {
    if (!root) return;
    const observer = observers.get(root);
    if (observer) {
      observer.disconnect();
      observers.delete(root);
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(`[data-section="${NS}"]`).forEach(init);
  });

  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.getAttribute('data-section') === NS) init(e.target);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    if (e.target.getAttribute('data-section') === NS) unload(e.target);
  });
})();
/* =======================================================================
   VH — Stories & Reviews (Final JS)
   - "One Scroll" Parallax (Vertical scroll drives horizontal rail)
   - Video Autoplay (IntersectionObserver)
   - Icon-Only Mute Toggle
   ======================================================================= */

(function() {
  const NS = 'vh-stories-reviews';
  const SELECTOR = `[data-section="${NS}"]`;

  const init = (root) => {
    // 1. Safety Checks
    if (!root || !root.matches(SELECTOR)) return;
    if (root.dataset.vhInited) return; 
    root.dataset.vhInited = 'true';

    const rail = root.querySelector('.vh-reviews__rail');
    const videos = root.querySelectorAll('video[data-autoplay]');
    const muteButtons = root.querySelectorAll('.vh-reviews__mute');
    
    // Store cleanup functions for the unloader
    const cleanup = [];

    // --- 2. THE "ONE SCROLL" LOGIC (Smooth Scrub) ---
    // Maps vertical page progress to horizontal scroll position.
    let ticking = false;
    
    const updateScroll = () => {
      if (!rail) return;
      
      const rect = root.getBoundingClientRect();
      const viewHeight = window.innerHeight;
      const sectionHeight = rect.height;
      
      // Calculate progress (0 to 1)
      // 0 = Top of section entering bottom of viewport
      // 1 = Bottom of section leaving top of viewport
      const totalDistance = viewHeight + sectionHeight;
      const distance = viewHeight - rect.top;
      let progress = distance / totalDistance;

      // Clamp strictly between 0 and 1
      progress = Math.max(0, Math.min(1, progress));

      // Calculate total horizontal scrollable width
      const maxScroll = rail.scrollWidth - rail.clientWidth;

      // Apply smoothness
      if (maxScroll > 0) {
        rail.scrollLeft = progress * maxScroll;
      }
      
      ticking = false;
    };

    const onScroll = () => {
      // Disable "One Scroll" effect if user prefers reduced motion
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      
      if (!ticking) {
        window.requestAnimationFrame(updateScroll);
        ticking = true;
      }
    };

    // Bind Scroll & Resize
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    
    // Initial calculation to set correct position on load
    updateScroll();
    
    cleanup.push(() => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    });


    // --- 3. VIDEO AUTOPLAY ---
    if (videos.length > 0) {
      const observer = new IntersectionObserver((entries) => {
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        entries.forEach(entry => {
          // Play only when intersecting and motion is allowed
          if (entry.isIntersecting && !reduceMotion) {
            entry.target.play().catch(() => {});
          } else {
            entry.target.pause();
          }
        });
      }, { threshold: 0.5 }); // 50% visible triggers play

      videos.forEach(video => observer.observe(video));
      cleanup.push(() => observer.disconnect());
    }


    // --- 4. MUTE TOGGLES (Icon Only) ---
    muteButtons.forEach(btn => {
      const video = btn.closest('.vh-reviews__media')?.querySelector('video');
      if (!video) return;

      const toggleMute = (e) => {
        e.preventDefault();
        e.stopPropagation();

        video.muted = !video.muted;
        
        // Update ARIA state
        // pressed="true" means Muted (Icon shows speaker with line/off)
        // pressed="false" means Unmuted (Icon shows speaker sound)
        // Note: Logic follows the CSS selector .vh-reviews__mute[aria-pressed="false"] .vh-ic-x { display: none; }
        btn.setAttribute('aria-pressed', video.muted ? 'true' : 'false');
      };

      btn.addEventListener('click', toggleMute);
      cleanup.push(() => btn.removeEventListener('click', toggleMute));
    });

    // --- 5. CLEANUP HOOK ---
    root._vhTeardown = () => cleanup.forEach(fn => fn());
  };

  const unload = (root) => {
    if (root && root._vhTeardown) {
      root._vhTeardown();
      delete root.dataset.vhInited;
    }
  };

  // Shopify Theme Editor Events
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:unload', (e) => unload(e.target));
  
  // Initialize on Load
  document.querySelectorAll(SELECTOR).forEach(init);
})();

 
/* ===== VH — Word Splash (section) ===== */
(function () {
  function init(root) {
    if (!root || !root.matches('[data-section="vh-word-splash"]')) return;
    const stack = root.querySelector('.vh-word-splash__stack');
    if (!stack) return;

    // Trigger the “rest” state once visible.
    if (stack.dataset.animate === 'true') {
      const stagger = Number(stack.dataset.stagger || 0);

      stack.querySelectorAll('.vh-word-splash__line').forEach((el, i) => {
        const base = parseInt(el.style.getPropertyValue('--delay') || '0', 10);
        el.style.setProperty('--delay', `${base + i * stagger}ms`);
      });

      const io = new IntersectionObserver((entries) => {
        for (const e of entries) {
          if (e.isIntersecting) {
            stack.classList.add('rest-now');
            io.disconnect();
            break;
          }
        }
      }, { threshold: 0.25 });

      io.observe(root);
      root.__vhWS = { io };
    }
  }

  function unload(root) {
    if (root?.__vhWS?.io) root.__vhWS.io.disconnect();
    if (root) delete root.__vhWS;
  }

  const boot = () => document.querySelectorAll('[data-section="vh-word-splash"]').forEach(init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else { boot(); }

  document.addEventListener('shopify:section:load',  (e) => init(e.target));
  document.addEventListener('shopify:section:unload',(e) => unload(e.target));
})();
/* === VH — Global Architecture === */

(function() {
  'use strict';

  // --- 1. DOUBLE VIDEO LOGIC ---
  const DoubleVideo = {
    SEL: {
      ROOT: '[data-section="vh-double-video"]',
      VIDEO: '.vh-double-video__video',
      PLAYING_CLASS: 'is-playing'
    },
    registry: new WeakMap(),

    attemptPlay: (video) => {
      if (video.paused) {
        const p = video.play();
        if (p && p.catch) p.catch(() => { /* Autoplay blocked */ });
      }
    },

    attemptPause: (video) => {
      if (!video.paused) video.pause();
    },

    init: (root) => {
      if (!root || DoubleVideo.registry.has(root)) return;
      const videos = Array.from(root.querySelectorAll(DoubleVideo.SEL.VIDEO));
      
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            videos.forEach(v => {
              if (v.preload === 'none') {
                v.preload = 'auto';
                if (v.dataset.srcMp4) v.src = v.dataset.srcMp4; 
              }
            });
            videos.forEach(DoubleVideo.attemptPlay);
            root.classList.add(DoubleVideo.SEL.PLAYING_CLASS);
          } else {
            videos.forEach(DoubleVideo.attemptPause);
          }
        });
      }, { rootMargin: '50% 0px 50% 0px', threshold: 0.01 });

      observer.observe(root);
      DoubleVideo.registry.set(root, { observer });
    },

    unload: (root) => {
      const record = DoubleVideo.registry.get(root);
      if (!record) return;
      if (record.observer) record.observer.disconnect();
      DoubleVideo.registry.delete(root);
    }
  };

  // --- 2. GLOBAL SMOOTH SCROLL ---
  const SmoothScroll = {
    init: () => {
      let prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      
      window.matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', e => {
        prefersReduced = e.matches;
      });

      document.addEventListener('click', (event) => {
        const link = event.target.closest && event.target.closest('a[data-scroll]');
        if (!link) return;

        const href = (link.getAttribute('href') || '').trim();
        if (!href || href.charAt(0) !== '#') return;

        const target = document.getElementById(href.slice(1));
        if (!target) return;

        event.preventDefault();

        const container = link.closest('[data-scroll-offset]');
        const offset = container ? (parseInt(container.getAttribute('data-scroll-offset'), 10) || 0) : 0;

        window.scrollTo({
          top: window.pageYOffset + target.getBoundingClientRect().top - offset,
          behavior: prefersReduced ? 'auto' : 'smooth'
        });

        target.setAttribute('tabindex', '-1');
        try { target.focus({ preventScroll: true }); } catch (err) { target.focus(); }
        setTimeout(() => target.removeAttribute('tabindex'), 250);
      }, { capture: true, passive: false });
    }
  };

  // --- 3. LIFECYCLE HOOKS ---
  const boot = () => {
    document.querySelectorAll(DoubleVideo.SEL.ROOT).forEach(DoubleVideo.init);
    SmoothScroll.init();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.matches(DoubleVideo.SEL.ROOT)) DoubleVideo.init(e.target);
  });
  
  document.addEventListener('shopify:section:unload', (e) => {
    if (e.target.matches(DoubleVideo.SEL.ROOT)) DoubleVideo.unload(e.target);
  });
})();
/* === VH — More Splash & Contact Initialization === */

(function() {
  // --- More Splash Logic ---
  const initMoreSplash = (root) => {
    // Determine if the target is the section itself or contains it
    const section = root.classList?.contains('vh-more-splash') ? root : root.querySelector('.vh-more-splash');
    if (!section || section.dataset.vhInitialized) return;

    if (!('IntersectionObserver' in window)) {
      section.classList.add('vh-more-splash--visible');
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          section.classList.add('vh-more-splash--visible');
          observer.unobserve(section);
        }
      });
    }, { threshold: 0.3 });

    observer.observe(section);
    section._vhSplashObserver = observer;
    section.dataset.vhInitialized = "true";
  };

  const teardownMoreSplash = (root) => {
    const section = root.classList?.contains('vh-more-splash') ? root : root.querySelector('.vh-more-splash');
    if (!section) return;
    
    if (section._vhSplashObserver) {
      section._vhSplashObserver.disconnect();
      delete section._vhSplashObserver;
    }
    delete section.dataset.vhInitialized;
  };

  // --- Contact Section Logic ---
  const initContact = (root) => {
    const section = root.classList?.contains('vh-contact') ? root : root.querySelector('.vh-contact');
    if (!section || section.dataset.vhInitialized) return;

    section.querySelectorAll('.vh-contact__error-link').forEach(a => {
      a.addEventListener('click', (e) => {
        const href = a.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;
        const el = section.querySelector(href);
        if (el) el.focus();
      }, { passive: true });
    });
    section.dataset.vhInitialized = "true";
  };

  const teardownContact = (root) => {
    const section = root.classList?.contains('vh-contact') ? root : root.querySelector('.vh-contact');
    if (!section) return;
    delete section.dataset.vhInitialized;
  };

  // --- Global Lifecycle Hooks ---
  const handleLoad = (e) => {
    initMoreSplash(e.target);
    initContact(e.target);
  };

  const handleUnload = (e) => {
    teardownMoreSplash(e.target);
    teardownContact(e.target);
  };

  document.addEventListener('shopify:section:load', handleLoad);
  document.addEventListener('shopify:section:unload', handleUnload);

  // Initial load
  document.querySelectorAll('.vh-more-splash').forEach(initMoreSplash);
  document.querySelectorAll('.vh-contact').forEach(initContact);
})();
/* ===========================================================
   VH — Footer Reveal (JS Logic)
   Standard: Vivid Engineering v2
   =========================================================== */

(function() {
  const SELECTORS = {
    reveal: '.vh-reveal',
    footer: '.section-vh-footer', // Core Dawn/Vivid footer class
    body: 'body'
  };

  // Map to store observer references for cleanup
  const observers = new WeakMap();

  const setFooterMargin = (revealSection, footer) => {
    if (!revealSection || !footer) return;

    // 1. Get computed style to read the CSS variables
    const style = getComputedStyle(revealSection);
    const isMobile = window.innerWidth <= 768;

    // 2. Read the specific height tokens set in the Liquid schema
    // We do NOT use offsetHeight here because the CSS includes a +400px buffer
    const heightVar = isMobile 
      ? style.getPropertyValue('--vh-reveal-height-mobile') 
      : style.getPropertyValue('--vh-reveal-height-desktop');

    // 3. Apply as margin to the main footer to create the "window"
    if (heightVar) {
      footer.style.marginBottom = heightVar.trim();
    }
  };

  const init = (container) => {
    // Scoping: Ensure we are only initializing if this specific section is present
    const revealSection = container.querySelector(SELECTORS.reveal);
    if (!revealSection) return;

    // Find the main footer (usually outside this section)
    const footer = document.querySelector(SELECTORS.footer);
    if (!footer) {
      console.warn('VH — Footer Reveal: Main footer element not found. Effect disabled.');
      return;
    }

    // A. Initial Calculation
    requestAnimationFrame(() => setFooterMargin(revealSection, footer));

    // B. Resize Observer (More performant than window.resize)
    const resizeObserver = new ResizeObserver((entries) => {
      // Use requestAnimationFrame to debounce visually
      window.requestAnimationFrame(() => {
        setFooterMargin(revealSection, footer);
      });
    });

    resizeObserver.observe(document.body);
    observers.set(container, resizeObserver);
  };

  const teardown = (container) => {
    // 1. Disconnect Observer
    const observer = observers.get(container);
    if (observer) {
      observer.disconnect();
      observers.delete(container);
    }

    // 2. Cleanup Styles (Reset footer margin)
    const footer = document.querySelector(SELECTORS.footer);
    if (footer) {
      footer.style.marginBottom = '';
    }
  };

  // --- Shopify Theme Editor Lifecycle Events ---
  
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:unload', (e) => teardown(e.target));

  // Init existing sections on page load
  document.querySelectorAll('[data-section-type="vh-footer-reveal"]').forEach((el) => {
    // The container is the parent of the div with the data attribute in standard Dawn/Shopify structure
    // But since our selector finds .vh-reveal inside, we can pass the section container or the element itself.
    // Standard pattern: pass the container that holds the liquid section.
    init(el.closest('.shopify-section') || el.parentNode);
  });

})();

/* === VH — Reward Popup ====================================== */
(function () {
  const SECTION_SELECTOR = '[data-section="vh-reward-popup"]';
  const SEEN_KEY_PREFIX = 'vhRewardPopupSeen_';
  const stateMap = new WeakMap();

  function getFocusable(container) {
    if (!container) return [];
    return Array.from(container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter((el) => !el.hasAttribute('aria-hidden'));
  }

  function shouldShowOnDevice(section) {
    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    const showDesktop = section.dataset.popupShowDesktop === 'true';
    const showMobile = section.dataset.popupShowMobile === 'true';
    return (isMobile && showMobile) || (!isMobile && showDesktop);
  }

  function hasSeenRecently(storageKey, expiryDays) {
    if (!window.localStorage || !expiryDays) return false;
    try {
      const raw = window.localStorage.getItem(storageKey);
      if (!raw) return false;
      const data = JSON.parse(raw);
      if (!data.time) return false;
      const age = Date.now() - data.time;
      const maxAge = expiryDays * 24 * 60 * 60 * 1000;
      return age < maxAge;
    } catch (e) { return false; }
  }

  function markSeen(storageKey) {
    if (!window.localStorage) return;
    try { window.localStorage.setItem(storageKey, JSON.stringify({ time: Date.now() })); } catch (e) {}
  }

  function openPopup(section) {
    const overlay = section.querySelector('[data-vh-popup-overlay]');
    const dialog = section.querySelector('[data-vh-popup-dialog]');
    if (!overlay || !dialog) return;

    // --- SCROLL LOCK ---
    document.body.style.overflow = 'hidden'; 
    // -------------------

    dialog.hidden = false;
    // Removing hidden from overlay manually to be safe
    overlay.removeAttribute('hidden');
    
    section.classList.add('is-active');

    const focusables = getFocusable(dialog);
    const first = focusables[0];
    const previousActive = document.activeElement;

    stateMap.set(section, {
      ...(stateMap.get(section) || {}),
      focusables, first, previousActive, isOpen: true
    });

    if (first && typeof first.focus === 'function') first.focus();
  }

  function closePopup(section) {
    const overlay = section.querySelector('[data-vh-popup-overlay]');
    const dialog = section.querySelector('[data-vh-popup-dialog]');
    if (!overlay || !dialog) return;

    // --- SCROLL UNLOCK ---
    document.body.style.overflow = '';
    // ---------------------

    dialog.hidden = true;
    overlay.setAttribute('hidden', '');
    section.classList.remove('is-active');

    const st = stateMap.get(section) || {};
    if (st.previousActive && typeof st.previousActive.focus === 'function') {
      st.previousActive.focus();
    }

    const storageKey = SEEN_KEY_PREFIX + (section.dataset.sectionId || '');
    const expiryDays = parseInt(section.dataset.popupExpiryDays || '0', 10);
    if (expiryDays > 0) markSeen(storageKey);

    stateMap.set(section, { ...st, isOpen: false });
  }

  function handleKeydown(event, section) {
    const st = stateMap.get(section);
    if (!st || !st.isOpen) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closePopup(section);
      return;
    }

    if (event.key === 'Tab') {
      const dialog = section.querySelector('[data-vh-popup-dialog]');
      const focusables = st.focusables || getFocusable(dialog);
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];

      if (event.shiftKey) {
        if (document.activeElement === first) {
          event.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    }
  }

  function initForm(section) {
    const form = section.querySelector('[data-vh-popup-form]');
    if (!form) return;
    const emailInput = form.querySelector('input[type="email"]');
    const errorEl = form.querySelector('[data-vh-popup-error]');
    const successEl = section.querySelector('[data-vh-popup-success]');
    const codeEl = section.querySelector('[data-vh-popup-code]');
    const cta = form.querySelector('.vh-cta');
    const storageKey = SEEN_KEY_PREFIX + (section.dataset.sectionId || '');
    const invalidMsg = form.dataset.errorInvalid || '';

    if (cta) {
      cta.addEventListener('click', function (e) {
        e.preventDefault();
        typeof form.requestSubmit === 'function' ? form.requestSubmit() : form.submit();
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const value = (emailInput && emailInput.value || '').trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value)) {
        if (errorEl) errorEl.textContent = invalidMsg;
        if (emailInput) emailInput.focus();
        return;
      }
      if (errorEl) errorEl.textContent = '';
      if (successEl) successEl.hidden = false;
      if (codeEl) codeEl.hidden = false;
      markSeen(storageKey);
    });
  }

  function initRewardPopup(section) {
    if (!section || stateMap.has(section)) return;
    const enabled = section.dataset.popupEnabled === 'true';
    if (!enabled || !shouldShowOnDevice(section)) return;

    const delay = parseInt(section.dataset.popupDelay || '0', 10);
    const expiryDays = parseInt(section.dataset.popupExpiryDays || '0', 10);
    const storageKey = SEEN_KEY_PREFIX + (section.dataset.sectionId || '');

    // NOTE: Uncomment the line below in production to stop showing the popup if already seen
    if (expiryDays > 0 && hasSeenRecently(storageKey, expiryDays)) return;

    const overlay = section.querySelector('[data-vh-popup-overlay]');
    const dialog = section.querySelector('[data-vh-popup-dialog]');
    const closeBtn = section.querySelector('[data-vh-popup-close]');

    if (!overlay || !dialog) return;

    const onOverlayClick = () => closePopup(section);
    const onCloseClick = () => closePopup(section);
    const onKeydown = (e) => handleKeydown(e, section);

    overlay.addEventListener('click', onOverlayClick, { passive: true });
    closeBtn && closeBtn.addEventListener('click', onCloseClick);
    document.addEventListener('keydown', onKeydown);

    initForm(section);

    const timeoutId = window.setTimeout(() => openPopup(section), Math.max(0, delay));

    stateMap.set(section, {
      timeoutId, isOpen: false, overlayHandler: onOverlayClick,
      closeHandler: onCloseClick, keydownHandler: onKeydown
    });
  }

  function unloadRewardPopup(section) {
    const st = stateMap.get(section);
    if (!section || !st) return;
    const overlay = section.querySelector('[data-vh-popup-overlay]');
    const closeBtn = section.querySelector('[data-vh-popup-close]');

    if (overlay && st.overlayHandler) overlay.removeEventListener('click', st.overlayHandler);
    if (closeBtn && st.closeHandler) closeBtn.removeEventListener('click', st.closeHandler);
    if (st.keydownHandler) document.removeEventListener('keydown', st.keydownHandler);
    if (st.timeoutId) window.clearTimeout(st.timeoutId);
    
    if(st.isOpen) document.body.style.overflow = '';

    stateMap.delete(section);
  }

  function initAll() { document.querySelectorAll(SECTION_SELECTOR).forEach(initRewardPopup); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.matches && e.target.matches(SECTION_SELECTOR)) initRewardPopup(e.target);
  });
  document.addEventListener('shopify:section:unload', (e) => {
    if (e.target.matches && e.target.matches(SECTION_SELECTOR)) unloadRewardPopup(e.target);
  });
})();

/* === VH — Judge.me (Lite) Lifecycle === */
(function() {
  const init = (root) => {
    // 1. Guard Clause: specific to this section
    if (!root || !root.classList.contains('vh-judgeme-lite')) return;

    console.log('VH: Reloading Judge.me widget...');

    // 2. Check if Judge.me global object exists
    if (window.jdgm && window.jdgm.widget) {
      // 3. Force re-install of the widget on the new DOM elements
      // We use a small timeout to ensure the DOM injection is complete
      setTimeout(() => {
        window.jdgm.widget.autoInstall();
      }, 100);
    }
  };

  // Standard Vivid Lifecycle Hooks
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  
  // Initial Load (for when the page first opens)
  document.querySelectorAll('.vh-judgeme-lite').forEach(init);
})();

/* === VH — Collapsible (Accordion Logic v3) === */
(function() {
  const NS = 'vh-collapsible';
  const TRANSITION_MS = 400; // Must match CSS 0.4s

  // Helper: Smoothly close a details element
  const closeDetails = (details) => {
    if (!details.hasAttribute('open')) return;
    
    // 1. Mark as closing (locks interaction)
    details.dataset.status = 'closing';
    
    // 2. Wait for CSS transition to finish, then actually close
    setTimeout(() => {
      details.removeAttribute('open');
      details.dataset.status = 'idle';
    }, TRANSITION_MS); 
  };

  // Helper: Open a details element
  const openDetails = (details, group) => {
    // 1. Close siblings (Accordion behavior)
    if (group) {
      group.forEach(sibling => {
        if (sibling !== details && sibling.hasAttribute('open')) {
          closeDetails(sibling);
        }
      });
    }
    
    // 2. Open self (CSS handles the slide-down via grid-template-rows)
    details.setAttribute('open', '');
    details.dataset.status = 'opening';
    
    // 3. Reset status after animation
    setTimeout(() => {
      details.dataset.status = 'idle';
    }, TRANSITION_MS);
  };

  const init = (root) => {
    // Safety check + prevent double init
    if (!root || root.dataset.vhInited) return;
    root.dataset.vhInited = 'true';

    // Find all items in this specific section
    const items = root.querySelectorAll('details.vh-collapsible__item');
    
    items.forEach(details => {
      const summary = details.querySelector('summary');
      if (!summary) return;
      
      const onClick = (e) => {
        e.preventDefault(); // STOP native instant toggle
        e.stopPropagation();

        // Ignore clicks if currently animating
        if (details.dataset.status === 'closing' || details.dataset.status === 'opening') return;

        if (details.hasAttribute('open')) {
          closeDetails(details);
        } else {
          openDetails(details, items);
        }
      };

      summary.addEventListener('click', onClick);
      
      // Store reference for clean teardown
      details._vhClick = onClick;
    });
  };

  const unload = (root) => {
    if (!root) return;
    const items = root.querySelectorAll('details.vh-collapsible__item');
    items.forEach(details => {
      if (details._vhClick) {
        details.querySelector('summary').removeEventListener('click', details._vhClick);
        delete details._vhClick;
      }
    });
    delete root.dataset.vhInited;
  };

  // --- Bootstrap ---
  
  // 1. Find all sections and init
  document.querySelectorAll(`[data-section="${NS}"]`).forEach(init);
  
  // 2. Shopify Theme Editor Lifecycle
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.dataset.section === NS) init(e.target);
    // Handle case where section wrapper is the target
    const inner = e.target.querySelector(`[data-section="${NS}"]`);
    if (inner) init(inner);
  });
  
  document.addEventListener('shopify:section:unload', (e) => {
    if (e.target.dataset.section === NS) unload(e.target);
    const inner = e.target.querySelector(`[data-section="${NS}"]`);
    if (inner) unload(inner);
  });
})();